export default __webpack_public_path__ + "./images/lu.7a0d7718.png";